import { Dispatch } from 'react';
import { networkCall, apiBaseUrl } from '../../utils/networkCall';
import isEmpty from 'lodash/isEmpty';

export const FB_TEMPLATE_LOADING = "FB_TEMPLATE_LOADING";
export const FB_TEMPLATE_SUCCESS = "FB_TEMPLATE_SUCCESS";
export const FB_TEMPLATE_FAILED = "FB_TEMPLATE_FAILED";

export const FB_TEMPLATES_ADD_MORE_LOADING = "FB_TEMPLATES_ADD_MORE_LOADING";
export const FB_TEMPLATES_ADD_MORE = "FB_TEMPLATES_ADD_MORE";
export const CLEAR_ALL_TEMPLATE_DATAS = "CLEAR_ALL_TEMPLATE_DATAS";
export const FB_TEMPLATES_UPDATE_FILTERS = "FB_TEMPLATES_UPDATE_FILTERS";

export const loadFBTemplates = (limit: number, offset: number, search:any = undefined, service_id:any = undefined, selectedChannels: string[]) => {
    return (dispatch:Dispatch<any>) => {
        
        let URL = `/template?limit=${limit}&offset=${offset}`;
        if(search){
            URL = URL + `&title=${search}`;
        }
        if(service_id){
            URL = URL + `&service_id=${service_id}`;
        }
        
        let loadingState = FB_TEMPLATE_LOADING;
        let successState = FB_TEMPLATE_SUCCESS;

        if(offset){
            loadingState = FB_TEMPLATES_ADD_MORE_LOADING;
            successState = FB_TEMPLATES_ADD_MORE;
        }

        dispatch({ type: loadingState, payload: {}});
        dispatch({ type: FB_TEMPLATES_UPDATE_FILTERS, payload: { search, selectedChannels }})
        networkCall("get", URL, apiBaseUrl.baseUrl)
        .then((res:any)=>{
            if(res.error && isEmpty(res.error)){
                dispatch({ type: successState, payload: {respose: res}});
            }else{
                dispatch({ type: FB_TEMPLATE_FAILED, payload: {error: res}});
            }
        }).catch((err)=>{
            if(err?.response?.data){
                dispatch({ type: FB_TEMPLATE_FAILED, payload: {error: err.response.data}});
            }
        });
    }
};

export const clearWholeDate = () => {
    return (dispatch:Dispatch<any>) => {
        dispatch({type: CLEAR_ALL_TEMPLATE_DATAS, payload: {}});
    }
}